import { TimelineMax, Sine, Power1 } from 'gsap'

export default {
  data () {
    return {
      tlBg: new TimelineMax()
    }
  },

  mounted () {
    // Need to group day and night to not mess up the stagger
    const treeGrp1 = this.$el.querySelectorAll('.day-bg .treesvg')
    const treeGrp2 = this.$el.querySelectorAll('.night-bg .treesvg')

    this.tlBg
    //  .staggerFromTo('.leavesvg', 2, {transformOrigin: '0% 100%', skewX: '4deg'}, {skewX: '-4deg', repeat: -1, yoyo: true}, 0.3, 0)
      .staggerFromTo(treeGrp1, 2.5, {transformOrigin: '0% 100%', skewX: '2deg'}, {skewX: '-2deg', repeat: -1, yoyo: true, ease: Power1.easeInOut}, 0.15, 0)
      .staggerFromTo(treeGrp2, 2.5, {transformOrigin: '0% 100%', skewX: '2deg'}, {skewX: '-2deg', repeat: -1, yoyo: true, ease: Power1.easeInOut}, 0.15, 0)
      .from('.flowers .grp', 0.5, {scale: 0, transformOrigin: 'center bottom', ease: Sine.easeInOut}, 0)
  },

  beforeDestroy () {
    this.tlBg.kill()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/timelines/bg.js